"use client"

import { useEffect, useState } from "react"

export function Version() {
  const [version, setVersion] = useState("")

  useEffect(() => {
    setVersion(process.env.NEXT_PUBLIC_VERSION ?? "")
  }, [])

  return <span>{version}</span>
}
